/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientMasterSymptomTypename = "PatientMasterSymptom" as const;

/**
 *
 * @export
 * @interface PatientMasterSymptom
 */
export interface PatientMasterSymptom {
  /**
   *
   * @type {string}
   * @memberof PatientMasterSymptom
   */
  masterCode: string;
  /**
   *
   * @type {string}
   * @memberof PatientMasterSymptom
   */
  masterName?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientMasterSymptom
   */
  readonly __typename?: string;
}

export function PatientMasterSymptomFromJSON(json: any): PatientMasterSymptom {
  return PatientMasterSymptomFromJSONTyped(json, false);
}

export function PatientMasterSymptomFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientMasterSymptom {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientMasterSymptomTypename,

    masterCode: json["master_code"],
    masterName: !exists(json, "master_name") ? undefined : json["master_name"],
  };
}

export function PatientMasterSymptomToJSON(object?: PatientMasterSymptom | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    master_code: value.masterCode,
    master_name: value.masterName,
  };
}
